import {Component, Inject, Injector, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {DIALOG_DATA} from '@angular/cdk/dialog';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {ChooserOptions} from './options/chooser.options';
import {DataResponse} from '../../../../network/service/data.response';
import {MatDialogRef} from '@angular/material/dialog';
import {ListResponse} from '../../../../network/service/list.response';

@Component({
  selector: 'app-chooser',
  standalone: false,
  templateUrl: './chooser.component.html',
  styleUrl: './chooser.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ChooserComponent extends BaseComponent implements OnInit, OnDestroy {
  chooserOptions = new ChooserOptions();
  list: any = [];
  title: any;
  addressMode: boolean = false;
  addressDetail?: any;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<ChooserComponent>, @Inject(DIALOG_DATA) public data: any) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        this.title = 'AddressSelect';
        break;
      case 'SPACE':
        this.title = 'SelectSpace';
        break;
      case 'POS':
        this.title = 'SelectPos';
        break;
    }
  }

  ngOnDestroy() {
    if (!this.data?.UserAddress && !this.data.Space) {
      this.noAction();
    }
  }

  override loadOnline() {
    super.loadOnline();
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        let filter = {};
        if (this.data?.DeliveryMethod) {
          filter = {
            Filter: {
              Values: [{
                Field: 'DeliveryMethodId',
                Type: 'EQ',
                Value: this.data.DeliveryMethod.DeliveryMethodId
              }, {
                Field: 'UserId',
                Type: 'EQ',
                Value: this.data.UserId
              }]
            },
            Order: {
              Field: 'Title',
              Type: 'ASC'
            }
          };
        }
        this.serviceApi.getUserAddresses(0, 0, '', 'ALL', filter).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.list = res.data;
            if (this.data?.UserAddress) {
              this.data.UserAddress = this.list.find((userAddress: any) => userAddress.UserAddressId === this.data.UserAddress.UserAddressId);
            }
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
        break;
      case 'SPACE':
        this.serviceApi.getSpaces(0, 0, '', 'ALL', undefined, {
          Filter: {
            Values: [{
              Field: 'Type',
              Type: 'EQ',
              Value: 'TABLE'
            }]
          },
        }).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.list = res.data;
            if (this.data?.Space) {
              this.data.Space = this.list.find((space: any) => space.SpaceId === this.data.Space.SpaceId);
            }
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
        break;
      case 'POS':
        this.list = this.data?.Poses;
        break;
    }
  }

  onChange(item: any) {
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        this.data.UserAddress = item;
        break;
      case 'SPACE':
        this.data.Space = item;
        break;
      case 'POS':
        this.data.Pos = item;
        break;
    }
  }

  noAction() {
    this.matDialogRef.close();
  }

  onChooseClicked() {
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        if (this.data?.UserAddress) {
          this.chooserOptions.onChoose(this.data.UserAddress);
          this.noAction();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant('SelectOneOfAddress'), false);
        }
        break;
      case 'SPACE':
        if (this.data?.Space) {
          this.chooserOptions.onChoose(this.data.Space);
          this.noAction();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant('SelectOneOfSpace'), false);
        }
        break;
      case 'POS':
        if (this.data?.Pos) {
          this.chooserOptions.onChoose(this.data.Pos);
          this.noAction();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant('SelectOneOfPos'), false);
        }
        break;
    }
  }

  onAddressDetailReceived(addressDetail: any) {
    this.addressDetail = addressDetail;
    if (!this.data.UserAddressId) {
      this.data.Title = addressDetail.Name;
      this.data.Address = addressDetail.Address.Road;
      this.data.Detail = addressDetail.DisplayName;
      this.data.PostalCode = addressDetail.Address.Postcode;
    }
  }

  onSubmitClicked() {
    (this.data.UserAddressId ? this.serviceApi.updateUserAddresses(this.data.UserAddressId, {
      Latitude: this.data.Latitude,
      Longitude: this.data.Longitude,
      Title: this.data.Title,
      Address: this.data.Address,
      Detail: this.data.Detail,
      PostalCode: this.data.PostalCode,
      Phone: this.data.Phone,
      RecipientFullName: this.data.RecipientFullName,
      Details: this.addressDetail
    }) : this.serviceApi.createUserAddresses({
      Latitude: this.data.Latitude,
      Longitude: this.data.Longitude,
      Title: this.data.Title,
      Address: this.data.Address,
      Detail: this.data.Detail,
      PostalCode: this.data.PostalCode,
      Phone: this.data.Phone,
      RecipientFullName: this.data.RecipientFullName,
      Details: this.addressDetail,
      UserId: this.data.UserId
    })).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onAddressClicked() {
    this.addressMode = true;
  }
}
